const {
  getFormContent
} = require('../lib/getFormContent');

/**
 * When a pair of assets are selected in the Connections section,
 * determines (in combination with the Weld Specification)
 * whether these assets are compatible
 * (i.e. whether they match a specification pair
 * in the Weld Specification section).
 *
 * @function evaluate - evaluate ucbWeldComplianceErrorTextBehavior
 */

const optionIdentifier = option => {
  if (option === undefined || option === null) {
    return undefined;
  }
  const [key] = Object.keys(option);
  return key;
};
const matchOptions = (op1, op2) => {
  const [k1] = Object.keys(op1 || {});
  const [k2] = Object.keys(op2 || {});
  if (k1 === undefined || k2 === undefined) {
    return true;
  }
  const match = k1 === k2;
  return match;
};
const matchAsset = (weldSpec, asset) => {
  if (weldSpec === undefined || asset === undefined) {
    return true;
  }
  const {
    assetType: assetType1,
    diameter: diameter1,
    wallThickness: wallThickness1,
    coatingType: coatingType1,
    grade: grade1
  } = weldSpec;
  const {
    formType: {
      identifier: formTypeIdentifier
    } = {},
    general: {
      diameter: diameter2,
      grade: grade2
    } = {},
    coatingType: coatingType2,
    wallThickness: wallThickness2
  } = asset;
  const assetType2 = {
    [formTypeIdentifier]: {}
  };
  return matchOptions(assetType1, assetType2) && matchOptions(diameter1, diameter2) && matchOptions(wallThickness1, wallThickness2) && matchOptions(coatingType1, coatingType2) && matchOptions(grade1, grade2);
};
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const formContentEvaluator = option => getFormContent(optionIdentifier(option), content, parentContentPath, transientContext, nativeFunctions);
  const {
    general: {
      weldSpecification
    } = {},
    aheadAsset: {
      asset: aheadAsset
    } = {},
    behindAsset: {
      asset: behindAsset
    } = {}
  } = content;
  if (aheadAsset === undefined || behindAsset === undefined) {
    return undefined;
  }
  const weldSpecificationContent = await formContentEvaluator(weldSpecification);
  const aheadAssetContent = await formContentEvaluator(aheadAsset);
  const behindAssetContent = await formContentEvaluator(behindAsset);
  const [aheadID] = Object.keys(aheadAsset);
  const [behindID] = Object.keys(behindAsset);
  if (aheadID === behindID) {
    return `${aheadAssetContent.title} cannot be connected to itself.`;
  }
  if (weldSpecification === undefined) {
    return undefined;
  }
  const {
    general: {
      specificationsAssetCollection = {}
    } = {}
  } = weldSpecificationContent;
  const keys = Object.keys(specificationsAssetCollection);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const value = specificationsAssetCollection[key];
    const {
      assetOne,
      assetTwo
    } = value;
    const match1a = matchAsset(assetOne, aheadAssetContent);
    const match2b = matchAsset(assetTwo, behindAssetContent);
    const match1b = matchAsset(assetOne, behindAssetContent);
    const match2a = matchAsset(assetTwo, aheadAssetContent);
    const match = match1a && match2b || match2a && match1b;
    if (match) {
      return undefined;
    }
  }
  return `${aheadAssetContent.title} cannot be connected` + ` to ${behindAssetContent.title} per` + ` Weld Specification ${weldSpecificationContent.title}.`;
};
module.exports = {
  evaluate
};